import React, { useState } from 'react';
import { BlueprintCanvas } from './components/BlueprintCanvas';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { ProjectShowcase } from './components/ProjectShowcase';
import { BeforeAfterSlider } from './components/BeforeAfterSlider';
import { PhilosophyProcess } from './components/PhilosophyProcess';
import { ProjectIndexTable } from './components/ProjectIndexTable';
import { AboutStudio } from './components/AboutStudio';
import { InquiryForm } from './components/InquiryForm';
import { Footer } from './components/Footer';
import { ProjectModal } from './components/ProjectModal';
import { Project, portfolioProjects } from './data/portfolioData';

export const App: React.FC = () => {
  const [activeProject, setActiveProject] = useState<Project | null>(null);

  const handleSelectProjectById = (id: string) => {
    const project = portfolioProjects.find((p) => p.id === id);
    if (project) {
      setActiveProject(project);
    }
  };

  const handleSelectProject = (project: Project) => {
    setActiveProject(project);
  };

  const handleCloseModal = () => {
    setActiveProject(null);
  };

  return (
    <div className="relative min-h-screen bg-[#0A0B0D] text-[#F4F4F0] overflow-x-hidden selection:bg-arch-accent selection:text-[#0A0B0D]">
      {/* Interactive Blueprint Canvas & Mouse Crosshair */}
      <BlueprintCanvas />

      {/* Main Architectural Navigation */}
      <Navbar />

      {/* Main Page Layout */}
      <main className="relative z-10">
        {/* 00: Hero & Editorial Statement */}
        <Hero onSelectProject={handleSelectProjectById} />

        {/* 01: Selected Works & Filterable Showcase */}
        <ProjectShowcase onSelectProject={handleSelectProject} />

        {/* 02: Interactive CAD Blueprint vs Built Structure Comparison */}
        <BeforeAfterSlider />

        {/* 03: 4-Phase Design Methodology & Scope of Practice */}
        <PhilosophyProcess />

        {/* 04: Chronological Monograph Archive & Row Hover Previews */}
        <ProjectIndexTable onSelectProject={handleSelectProject} />

        {/* 05: About the Architect, Philosophy, & Awards */}
        <AboutStudio />

        {/* 06: Netlify-Ready Client Consultation & Inquiry Form */}
        <InquiryForm />
      </main>

      {/* Architectural Dossier Slide-Over Modal */}
      <ProjectModal project={activeProject} onClose={handleCloseModal} />

      {/* Editorial Footer */}
      <Footer />
    </div>
  );
};

export default App;
